import { render } from "./tickets-kanban.vue?vue&type=template&id=51773d0d"
import script from "./tickets-kanban.vue?vue&type=script&lang=js"
export * from "./tickets-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__